import { render, staticRenderFns } from "./InventoriesTasksTable.vue?vue&type=template&id=62230f33&scoped=true&"
import script from "./InventoriesTasksTable.vue?vue&type=script&lang=ts&"
export * from "./InventoriesTasksTable.vue?vue&type=script&lang=ts&"
import style0 from "./InventoriesTasksTable.vue?vue&type=style&index=0&id=62230f33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62230f33",
  null
  
)

export default component.exports